import { render } from "./QuizTile.vue?vue&type=template&id=badf7bea&scoped=true"
import script from "./QuizTile.vue?vue&type=script&lang=js"
export * from "./QuizTile.vue?vue&type=script&lang=js"

import "./QuizTile.vue?vue&type=style&index=0&id=badf7bea&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badf7bea"]])

export default __exports__